// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DownCircleFilledSvg from "@fishx/icons-svg/es/asn/DownCircleFilled";
import FishxIcon from '../components/FishxIcon';

var DownCircleFilled = function DownCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DownCircleFilledSvg
  }));
};

DownCircleFilled.displayName = 'DownCircleFilled';
export default React.forwardRef(DownCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DownCircleFilled.js
// module id = 2449
// module chunks = 0